import { stateAbstract, actionsAbstract, mutationsAbstract } from '@/store/abstract'

const state = {
  ...stateAbstract,
  payDetail: {},
  payCount: null,
  payList: [],
  paymentsDetail: {},
  sourcesCount: null,
  sourcesDetail: {},
  sourcesList: []
}

export default {
  namespaced: true,
  state,
  actions: actionsAbstract,
  mutations: mutationsAbstract
}
